import {alertActionTypes as types} from './actionTypes';

export const error = message => ({type: types.ERROR_MSG, message});

export const clearErrors = () => ({type: types.CLEAR_ERROR});

export const success = message => ({type: types.SUCCESS_MSG, message});

export const clearSuccesses = () => ({type: types.CLEAR_SUCCESS});

export const warning = message => ({type: types.WARNING_MSG, message});

export const clearWarnings = () => ({type: types.CLEAR_WARNING});



// WEBPACK FOOTER //
// ./src/actions/alertActions.js